module.exports = __webpack_public_path__ + "img/511b299.jpg";